import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLDetailsElement> {
  static targets = ["content", "toggle"];

  declare readonly contentTarget: HTMLElement;
  declare readonly toggleTarget: HTMLElement;

  private observer?: ResizeObserver;
  private frame?: number;

  connect() {
    this.observer = new ResizeObserver(() => this.scheduleSync());
    this.observer.observe(this.element);
    this.syncToggle();
  }

  disconnect() {
    this.observer?.disconnect();
    if (this.frame) cancelAnimationFrame(this.frame);
  }

  toggle() {
    if (this.toggleTarget.classList.contains("is-hidden")) return;

    // Don't change state if we're selecting text
    if (!window.getSelection()?.isCollapsed) return;

    this.element.open = !this.element.open;
  }

  private scheduleSync() {
    // Avoid `ResizeObserver loop` warning by deferring the action
    if (this.frame) return;

    this.frame = requestAnimationFrame(() => {
      this.frame = undefined;
      this.syncToggle();
    });
  }

  private syncToggle() {
    if (this.element.open) return;

    this.toggleTarget.classList.toggle("is-hidden", !this.overflowing());
  }

  private overflowing(): boolean {
    return this.contentTarget.scrollHeight > this.contentTarget.clientHeight + 1;
  }
}
